module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Gc-Da-Eb.df5eb67e.png";